import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector
} from '@ngrx/store';

import { fromFeatureFlags } from '../reducers';
import { FlagSet } from '../models';

export const getFeatureFlagsState: MemoizedSelector<
unknown,
fromFeatureFlags.State
> = createFeatureSelector<fromFeatureFlags.State>('featureFlags');

/**
 * Selector to return all app level flags
 */
export const getAllAppFlags: MemoizedSelector<unknown, FlagSet> = createSelector(
  getFeatureFlagsState,
  (state: fromFeatureFlags.State) => state.app.flags
);

/**
 * Selector to return current app project key
 */
export const getAppProjectKey: MemoizedSelector<unknown, string> = createSelector(
  getFeatureFlagsState,
  (state: fromFeatureFlags.State) => state.app.projectKey
);

/**
 * Selector to get current status of a specific feature flag
 */
export const getAppFeatureFlag = ( props: { flag: string }) => createSelector(
  getFeatureFlagsState,
  (state: fromFeatureFlags.State) => state.app.flags[props.flag]
);

/**
 * Selector to get initialization state
 */
export const getFeatureFlagInitializationStatus: MemoizedSelector<unknown, boolean> = createSelector(
  getFeatureFlagsState,
  (state: fromFeatureFlags.State) => state.initialized
);
